import { render, staticRenderFns } from "./CreateAnnouncementPage.vue?vue&type=template&id=29a1427e&scoped=true"
import script from "./CreateAnnouncementPage.vue?vue&type=script&lang=js"
export * from "./CreateAnnouncementPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a1427e",
  null
  
)

export default component.exports